<template>
    <rkm-overlay>
        <rkm-layout-body title="Parametrização">
            <template v-slot:actions>                
                <rkm-button
                    @click="$refs.Form.store()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        
            <rkm-layout-content>
                <Form
                    @saved="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/painel-senha/parametrizacao/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleSave() {
            this.unsetShowExitFormConfirmation()
        },
    },
}
</script>